<template lang="pug">
  .v-container.grid-container.u-margin-auto(:class="loadingClass")
    div(v-cloak)
      .row
        .col.s12
          h1.h5.u-weight-bold
            template(v-if="isDigitalProductsOnly") Select a Billing Address
            template(v-else) Select a Shipping Address
      .row.row--flex.u-mtm
        .col.s12.l6.xl4.u-mbm(v-for="shipping in shippings")
          .c-panel.z-depth-1
            .c-panel__header
              .u-flex.u-flex-jc-space_between
                div
                  strong {{ shipping.label || shipping.name }}
                div
                  router-link(:to="'/checkout/shippings/' + shipping._id") Edit
            .c-panel__body
              .u-weight-bold {{ shipping.name }}
              div {{ shipping | formatAddress }}
            .c-panel__body
              button.c-btn.c-btn--fill.c-btn--primary(@click="selectShippingAddress(shipping._id)")
                template(v-if="isDigitalProductsOnly") Confirm billing address
                template(v-else) Ship to this address

        .col.s12.l6.xl4.u-mbm
          router-link.c-panel.c-panel--translucent.z-depth-1.v-panel-link(to="/checkout/shippings/new")
            .c-panel__body.u-align-center
              .c-btn.c-btn--primary.c-btn--circle
                i.icon-plus
              .u-mts
                template(v-if="isDigitalProductsOnly") Add Billing Address
                template(v-else) Add a New Shipping Address
</template>

<script>
import Shipments from '../../../stores/schema/injected/Shipments';
import ShoppingCarts from '../../../stores/schema/ShoppingCarts';
import addressUtil from '../../../util/address';

export default {
  name: 'select_shipping_address',
  data() {
    return {
      loading: true
    };
  },
  filters: {
    formatAddress: addressUtil.format
  },
  computed: {
    loadingClass() {
      return {
        'v-loading': this.loading,
        'c-loading': this.loading,
        'c-loading--opacity': this.loading
      };
    },
    shippings() {
      return this.$store.getters['shippings/list'];
    },
    cart() {
      return this.$store.getters['cart/current']({ populate: ['shipments'] });
    },
    isDigitalProductsOnly() {
      return ShoppingCarts.isDigitalProductsOnly(this.cart);
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$store
        .dispatch('shippings/fetchAll')
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;

          this.$alert(
            error.general ||
              'An error occurred. Please wait a moment before trying again.'
          );
        });
    },
    selectShippingAddress(shippingId) {
      this.loading = true;

      this.$store
        .dispatch('shippings/changeCurrent', {
          _id: shippingId
        })
        .then(() => {
          return this.$store.dispatch('cart/changeCartShipping', {
            wishlistId: this.cart.wishlistId
          });
        })
        .then(() => {
          this.loading = false;

          // 全てのShipmentsが配送不可の場合はエラーを表示する
          if (Shipments.isAllShipmentsUndeliverable(this.cart.shipments)) {
            this.$alert('All shipments are undeliverable');
            return false;
          }

          this.$router.push('/checkout').catch(() => {});
        })
        .catch((error) => {
          this.loading = false;

          this.$alert(
            error.general ||
              'An error occurred. Please wait a moment before trying again.'
          );
        });
    }
  }
};
</script>

<style scoped>
.v-container {
  max-width: 950px;
  padding: 0;
}

.v-loading {
  min-height: 50vh;
}

.v-panel-link {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 150px;
}
</style>
